import React from 'react'
import Checkbox from '@material-ui/core/Checkbox'
import FormControlLabel from '@material-ui/core/FormControlLabel'

const LabelCheckbox = ({ name, value, change, label }) => (
  <FormControlLabel
    key={name}
    component="fieldset"
    control={
      <Checkbox
        name={name}
        checked={value}
        onChange={change}
        margin="normal"
        color="primary"
      />
    }
    label={label}
  />
)

export default LabelCheckbox
